import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserLoginRequest } from '@ls-sharable/rbac/user-login/user-login.request';
import { UserLoginResponse } from '@ls-sharable/rbac/user-login/user-login.response';
import { AccountRegisterRequest } from '@ls-sharable/rbac/registration/account-register.request';
import { RestApiResponse } from '@ls-sharable/common/rest-api.response';

import { Injectable } from '@angular/core';

import { ApiService } from '../api.service';
import { SessionService } from '../session/session.service';
import { UserSession } from '../session/user-session';

@Injectable({ providedIn: 'root' })
export class AuthService {
    constructor(private api: ApiService, private session: SessionService) {
    }

    public login(request: UserLoginRequest): Observable<UserSession> {
        return this.api.post<UserLoginResponse>('/rest_api_v3/account/login', request).pipe(
            map(data => {
                const response = new UserLoginResponse(data);
                const userSession = new UserSession(response.userLoginInfo);
                this.session.setUserSession(userSession);
                return userSession;
            })
        );
    }

    public logout(withoutRequest = false): Observable<void> {
        const logout$: Observable<void> = withoutRequest
            ? of(undefined)
            : this.api.post<void>('/rest_api_v2/account/logout').pipe(tap(() => this.api.clearCacheAll()));

        return logout$.pipe(
            map(() => {
                this.session.clearUserSession();
            })
        );
    }

    public registerAccount(request: AccountRegisterRequest): Observable<RestApiResponse> {
        return this.api.post<RestApiResponse>('/rest_api_v3/account/registration', request);
    }
}
